import { atom, selectorFamily } from 'recoil'
import { featureFlags, FeatureFlags } from 'src/utils/feature-flags'
import { browserLogger } from 'src/utils/browser-logger'
import { keyFactory } from 'src/utils/recoil'
import { FeatureFlag } from 'src/utils/feature-flags'
import { currentUser } from 'src/atoms/user'
import { Role } from 'src/common-services'

const settingKey = keyFactory('settings')

export enum SettingsTabs {
  SETTINGS = 'SETTINGS',
  THEME = 'THEME',
}

export const open = atom<boolean>({
  key: settingKey('open'),
  default: false,
})

export const tab = atom<SettingsTabs>({
  key: settingKey('tab'),
  default: SettingsTabs.SETTINGS,
})

const featureFlagsOverrideStore = {
  get: (): FeatureFlags => {
    try {
      if (typeof window === 'undefined') {
        return []
      }
      const parsed = JSON.parse(localStorage.getItem('feature-flags-override') || '[]')
      return Object.keys(featureFlags).filter((key) => parsed.includes(key)) as FeatureFlags
    } catch (e) {
      browserLogger.error('unable to read local storage feature flags', e)
      return []
    }
  },
  set: (flags: FeatureFlags): void => {
    localStorage.setItem('feature-flags-override', JSON.stringify(flags))
  },
}

export const featureFlagsOverride = atom<FeatureFlags>({
  key: settingKey('feature-flags-override'),
  default: featureFlagsOverrideStore.get(),
  effects_UNSTABLE: [
    ({ onSet }) => {
      onSet((val) => {
        featureFlagsOverrideStore.set(val)
      })
    },
  ],
})

export const featureEnabled = selectorFamily<boolean, FeatureFlag>({
  key: settingKey('feature-enabled'),
  get:
    (key) =>
    ({ get }) => {
      const user = get(currentUser)
      if (user?.role !== Role.admin) {
        return false
      }
      const featureFlagsOverrideValue = get(featureFlagsOverride)
      return featureFlagsOverrideValue.includes(key)
    },
})
